import type { ComponentProps } from 'react'

import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import Link from 'next/link'

import * as styles from './content-navigation-children.styles'

type Props = {
  isCurrent: boolean
  label: string
} & ComponentProps<typeof Link>

export const ContentNavigationChildren = ({
  isCurrent,
  label,
  children,
  ...props
}: Props) => (
  <li css={styles.item}>
    <Link
      aria-current={isCurrent ? 'location' : undefined}
      css={styles.link}
      legacyBehavior={false}
      {...props}
    >
      <Typography
        noWrap
        color={isCurrent ? 'textPrimary' : 'textTertiary'}
        component="span"
        fontWeight={isCurrent ? 'medium' : 'regular'}
        variant="b2"
      >
        {label}
      </Typography>
    </Link>
    {
      /* 
          Use children for nested tree, otherwise use label prop
        */
      children
    }
  </li>
)
